import { observer } from 'mobx-react'
import styles from './OpportunityDetailsActions.sass'
import React from 'react'

interface OpportunityDetailsActionsProps {
  children: React.ReactNode
}

export default observer(function PickupActions({
  children,
}: OpportunityDetailsActionsProps) {
  return <div className={styles.actions}>{children}</div>
})
